/**
 * @file   src\components\AgentDashboard\ActionDropdown.js
 * @brief  This file is responsible for dropdown actions in dashboard
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { Dropdown } from "react-bootstrap";
import React from "react";
import TableMoreIconVertical from "../../images/table-more-vertical-icon.svg";
const ActionDropdown = (props) => {
  const {
    onItemEdit,
    onItemDelete,
    editText,
    deleteText,
    itemId,
    disableEdit,
    buyerListLinkText,
    showBuyerListingFormUrl,
    client_Want_ad_Id,
    hideEdit,
    onChangeStatus,
    currentStatus,
    show,
    onToggle,
    onAssignClient,
    assignClientText,
  } = props;

  const showStatusActions = typeof onChangeStatus === "function";
  const status = (currentStatus || "ACTIVE").toUpperCase();
  return (
    <Dropdown show={show} onToggle={onToggle}>
      <Dropdown.Toggle variant="" id="dropdown-basic1111">
        <img src={TableMoreIconVertical} />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        {!hideEdit ? (
          disableEdit ? (
            <Dropdown.Item
              onClick={() => showBuyerListingFormUrl(client_Want_ad_Id)}
            >
              {buyerListLinkText}
            </Dropdown.Item>
          ) : (
            <Dropdown.Item onClick={() => onItemEdit(itemId)}>
              {editText}
            </Dropdown.Item>
          )
        ) : (
          <></>
        )}
        {typeof onAssignClient === "function" && (
          <Dropdown.Item onClick={() => onAssignClient(itemId)}>
            {assignClientText || "Assign client"}
          </Dropdown.Item>
        )}
        {showStatusActions && status === "ACTIVE" && (
          <>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "PENDING")}>
              Mark pending
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "CLOSED")}>
              Close out (purchased)
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "ARCHIVED")}>
              Archive listing
            </Dropdown.Item>
          </>
        )}
        {showStatusActions && status === "PENDING" && (
          <>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "CLOSED")}>
              Close out (purchased)
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "ACTIVE")}>
              Re-activate
            </Dropdown.Item>
          </>
        )}
        {showStatusActions && (status === "CLOSED" || status === "ARCHIVED") && (
          <Dropdown.Item onClick={() => onChangeStatus(itemId, "ACTIVE")}>
            Re-activate
          </Dropdown.Item>
        )}
        <Dropdown.Item onClick={() => onItemDelete(itemId)}>
          {deleteText}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default ActionDropdown;
